import { useNavigate } from "react-router-dom";
import { useCart } from "../contexts/CartContext";
import CartItem from "../components/CartItem";
import useTitle from "../hooks/useTitle";
import { toast } from "react-toastify";

export default function CartPage() {
  useTitle("Cart | Astro Portal");
  const { items, subtotal, loading, error, updateItem, removeItem, clearCart } =
    useCart();
  const navigate = useNavigate();

  const handleUpdate = (id, qty) => {
    if (qty < 1) return;
    updateItem(id, qty)
      .then(() => toast.success("Quantity updated"))
      .catch(() => toast.error("Update failed"));
  };

  const handleRemove = (id) => {
    removeItem(id)
      .then(() => toast.success("Item removed"))
      .catch(() => toast.error("Remove failed"));
  };

  if (loading)
    return <div className="text-center py-5">🛒 Loading your cart...</div>;
  if (error)
    return <div className="text-danger text-center">Error: {error}</div>;

  // ✅ Check auth via sessionStorage
  const handleCheckout = () => {
    const session = JSON.parse(sessionStorage.getItem("authSession"));

    if (!session || !session.jwt_token) {
      navigate("/login?redirect=/checkout");
      return;
    }

    navigate("/checkout");
  };

  return (
    <div className="container my-5" style={{ maxWidth: 900 }}>
      <h3 className="mb-4 fw-bold">Your Shopping Cart</h3>

      {items.length === 0 ? (
        <div className="text-center py-5 border rounded bg-light">
          <h5>Your cart is empty 😔</h5>
          <p style={{ color: "#666" }}>Add some items to see them here!</p>
          <a href="/" className="btn btn-primary mt-3">
            Continue Shopping
          </a>
        </div>
      ) : (
        <>
          <div className="bg-white shadow-sm rounded p-3">
            {items.map((item) => (
              <CartItem
                key={item.id}
                item={item}
                onUpdate={handleUpdate}
                onRemove={handleRemove}
              />
            ))}
          </div>

          <div className="mt-4 text-end bg-light p-3 rounded">
            <h5>
              Subtotal:{" "}
              <span style={{ color: "#d32f2f", fontWeight: 700 }}>
                ₹{Number(subtotal).toFixed(2)}
              </span>
            </h5>

            <div className="mt-3 d-flex justify-content-end gap-2">
              <button onClick={handleCheckout} className="btn btn-success px-4">
                Proceed to Checkout
              </button>

              <button
                className="btn btn-outline-danger px-4"
                onClick={clearCart}
              >
                Clear Cart
              </button>
            </div>
          </div>
        </>
      )}
    </div>
  );
}
